import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-wq-model",
  "use": "icon-icon-wq-model-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-wq-model\">\r\n<rect width=\"20\" height=\"5\" rx=\"1\" fill=\"white\" />\r\n<rect x=\"10\" y=\"7\" width=\"10\" height=\"3\" rx=\"1\" fill=\"white\" />\r\n<rect x=\"10\" y=\"12\" width=\"10\" height=\"8\" rx=\"1\" fill=\"white\" />\r\n<rect y=\"7\" width=\"8\" height=\"13\" rx=\"1\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol